module.exports = __webpack_public_path__ + "static/img/sfmhy_2.b04fb37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/sfmhy_2.jpg
// module id = Op+t
// module chunks = 15